module.exports = __webpack_public_path__ + "img/sort-numeric-down-alt.3086872b.svg";